// src/pages/Facebook.js
import React from 'react';
import FeaturePageLayout from '../components/FeaturePageLayout';
import { 
    IoLogoFacebook,
    IoNewspaperOutline, 
    IoPeopleOutline, 
    IoChatboxOutline, 
    IoBarChartOutline 
} from 'react-icons/io5';
import image1 from '../assets/images/Generate.png';
import image2 from '../assets/images/Schedule2.png';
import image3 from '../assets/images/Messages.png';
import image4 from '../assets/images/Analytics.png';
import heroBg from '../assets/images/facebook-background.png';

const breadcrumbSchema = { "@context": "https://schema.org", "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://oolook.in/" }, { "@type": "ListItem", "position": 2, "name": "Facebook Management", "item": "https://oolook.in/facebook" }] };
const serviceSchema = { "@context": "https://schema.org", "@type": "Service", "serviceType": "Facebook Marketing Software", "provider": { "@type": "Organization", "name": "Oolook" }, "name": "AI Facebook Management Tool", "description": "Manage your Facebook Pages and Groups with Oolook. Use AI to create and schedule posts, manage comments, and analyze your performance.", "url": "https://oolook.in/facebook" };

const pageData = {
  seo: {
    title: "AI Facebook Management Tool | Oolook",
    description: "Simplify your Facebook marketing. Oolook's AI tools help you create and schedule content, manage your community in Pages and Groups, and track your ROI.",
    image: 'https://oolook.in/og/facebook.png',
    schemas: [breadcrumbSchema, serviceSchema]
  },
  hero: {
    icon: IoLogoFacebook,
    title: "Unlock Your Facebook Potential",
    subtitle: "Manage your Facebook Pages and Groups with effortless precision. Oolook helps you create engaging content, build your community, and drive real business results.",
    backgroundImage: heroBg
  },
  featureSection: {
    title: "Comprehensive Management for Facebook",
    subtitle: "From content creation to community moderation, Oolook provides a complete solution for your Facebook strategy.",
    features: [
      { title: "AI Content for High Engagement", description: "Generate compelling posts, articles, and video descriptions tailored for the Facebook algorithm.", image: image1 },
      { title: "Schedule Posts in Advance", description: "Plan your content calendar for both Pages and Groups. Set your schedule and let Oolook publish for you.", image: image2 },
      { title: "Manage All Comments & Messages", description: "Bring all your Facebook comments and Messenger conversations into our Unified Inbox for faster responses.", image: image3 },
      { title: "Track Page & Group Analytics", description: "Monitor your reach, engagement, and audience growth to understand what's working and optimize your strategy.", image: image4 }
    ]
  },
  benefitGrid: {
    title: "The Advantage of a Streamlined Facebook Workflow",
    benefits: [
      { icon: IoNewspaperOutline, title: "Publish Better Content", description: "Use AI to craft high-quality posts that capture attention and encourage interaction." },
      { icon: IoPeopleOutline, title: "Grow Your Community", description: "Save time on management so you can focus on building a thriving and engaged community." },
      { icon: IoChatboxOutline, title: "Improve Responsiveness", description: "Engage with your audience faster and more effectively with a unified inbox and smart replies." },
      { icon: IoBarChartOutline, title: "Maximize Your ROI", description: "Use data-driven insights to improve your organic reach and optimize your Facebook ad spend." }
    ]
  },
  // ✅ ADDED MISSING STEP-BY-STEP DATA
  stepByStep: {
    title: "Master Your Facebook Presence",
    subtitle: "A simple workflow to manage your Pages and Groups effectively.",
    steps: [
        { title: "1. Connect Your Facebook Account", description: "Securely link your Facebook Pages and any Groups you manage to your Oolook dashboard." },
        { title: "2. Create Your First Post", description: "Use the AI generator to draft an engaging post, or create one from scratch and add it to your content library." },
        { title: "3. Schedule to Your Calendar", description: "Drag your post onto the visual calendar and select which Pages or Groups you want to publish to." },
        { title: "4. Engage and Analyze", description: "Manage incoming comments from the Unified Inbox and track post performance in your analytics dashboard." }
    ]
  },
  // ✅ ADDED MISSING TARGET AUDIENCE DATA
  targetAudience: {
    title: "The Smart Choice for Community-Focused Brands"
  }
};

const Facebook = () => {
  return <FeaturePageLayout pageData={pageData} />;
};

export default Facebook;